<clr-dropdown
  class="actions-dropdown"
  (clickOutside)="showInnerDropdown = false"
  [clrCloseMenuOnItemClick]="false"
>
  <button class="nav-icon dropdown-trigger actions-dropdown__trigger" clrDropdownTrigger>
    <clr-icon shape="cog" size="22" class="actions-dropdown__trigger-icon"></clr-icon>
  </button>
  <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right" class="actions-dropdown__menu">
    <label for="file-input" class="actions-dropdown__menu-item" clrDropdownItem
          *ngIf="pageName === pageNames.MAP">Завантаження аналізу ґрунтів</label>
  <label [routerLink]="'/catalogs/' + catalogs[0].routerLink" (click)="closeDropdown()" class="actions-dropdown__menu-item" clrDropdownItem
          [hidden]="!(isAdmin$ | async)">Довідники</label>
  </clr-dropdown-menu>
</clr-dropdown>

<input
  hidden
  type="file"
  multiple
  id="file-input"
  accept=".zip,.rar,.7zip"
  [disabled]="soilAnalysisUploading"
  (change)="filesAdded.emit($event.target.files)"
/>
